import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles({
  appContainer: {
    height: '100vh',
    width: '100%',
    overflow: 'auto',
    overflowX: 'hidden',
    backgroundImage: `url(/30495.jpg)`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  preloader: {
    position: 'fixed',
    top: 0,
    left: 0,
    height: '100vh',
    width: '100%',
    backgroundColor: 'rgba(255, 255, 255, 0.8)', // Light overlay
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '2rem',
    fontWeight: 'bold',
    color: '#000', // Preloader text color
  },
  pageWrapper: {
    display: "flex",
  },
  contentWrapper: {
    width: "100%",
    height: "100%",
    backgroundColor: "#B2B2B2",
  },
});
